import * as actions from './config.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store} from '@ngrx/store';
import { CallUserConfigModel } from '@smarttask-common/src/lib/models/CRM/Call/CallUserConfigModel';

export const callUserConfigAdapter = createEntityAdapter<CallUserConfigModel>({
  selectId: x => x.config_id
});
export interface CallUserConfigState extends EntityState<CallUserConfigModel>{
  selected_config_id: number
};

export const initialState: CallUserConfigState = callUserConfigAdapter.getInitialState({
  selected_config_id: undefined 
}); 


export function CallUserConfigReducers(
  state: CallUserConfigState = initialState,
  action: actions.CallUserConfiglistActions
){
  switch(action.type){
    case actions.CallUserConfigActionTypes.UPDATE_SELECTED_ID:
      state = {...state,selected_config_id: action.selected_config_id};
      return state;

    case actions.CallUserConfigActionTypes.ADD_CALLUSERCONFIG: 
      return callUserConfigAdapter.addOne(action.callUserConfig, {...state,selected_config_id: state.selected_config_id});

    case actions.CallUserConfigActionTypes.ADD_CALLUSERCONFIGS:
      return callUserConfigAdapter.addMany(action.callUserConfigs,{...state,selected_config_id: state.selected_config_id});

    case actions.CallUserConfigActionTypes.UPSERT_CALLUSERCONFIG:
      return callUserConfigAdapter.upsertOne(action.callUserConfig,{...state,selected_config_id: state.selected_config_id});
      
    case actions.CallUserConfigActionTypes.UPSERT_CALLUSERCONFIGS:
      return callUserConfigAdapter.upsertMany(action.callUserConfigs,{...state,selected_config_id: state.selected_config_id});
  
    case actions.CallUserConfigActionTypes.UPDATE_CALLUSERCONFIG:
      return callUserConfigAdapter.updateOne({
        id: action.id,
        changes: action.changes
      },{...state,selected_config_id: state.selected_config_id});

    case actions.CallUserConfigActionTypes.UPDATE_CALLUSERCONFIGS:
      return callUserConfigAdapter.updateMany(action.updates,{...state,selected_config_id: state.selected_config_id});

    case actions.CallUserConfigActionTypes.DELETE_CALLUSERCONFIG:
      // if(state.selectedCallUserConfigId == action.id){
      //   state.selectedCallUserConfigId = undefined;
      // }
      return callUserConfigAdapter.removeOne(action.id,{...state,selected_config_id: state.selected_config_id});

    case actions.CallUserConfigActionTypes.DELETE_CALLUSERCONFIGS:
      // if(action.ids.indexOf(state.selectedCallUserConfigId) > -1){
      //   state.selectedCallUserConfigId = undefined;
      // }
      return callUserConfigAdapter.removeMany(action.ids,{...state,selected_config_id: state.selected_config_id});

    case actions.CallUserConfigActionTypes.DELETE_STATE:
      state.selected_config_id = undefined;
      return callUserConfigAdapter.removeAll(state);

    default:
      return state;
  }
}

export const getCallUserConfigState = createFeatureSelector<CallUserConfigState>('callUserConfig');

const getSelectedCallUserConfigIdState = (state: CallUserConfigState) => { 
  return state.selected_config_id
};
export const getSelectedCallUserConfigId = createSelector(getCallUserConfigState, getSelectedCallUserConfigIdState);

export const getSelectedCallUserConfig = createSelector(getCallUserConfigState, (state: CallUserConfigState)=>{
  if(state.selected_config_id == undefined){
    return undefined;
  }
  return state.entities[state.selected_config_id];
})

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = callUserConfigAdapter.getSelectors(getCallUserConfigState);